import {
    useMutation,
} from '@tanstack/react-query'
import {
    useJWTToken,
} from 'app/Auth'

import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'
import requests from 'app/requests/Order/OrderBilling.requests'
import simpleApi from 'app/services/simpleApi'

const useSendToSap = ({
    onSuccess,
}: {
    onSuccess: () => void,
}) => {
    const token = useJWTToken()
    const {
        onSuccess: onSuccessRequest,
        onError: onErrorRequest,
    } = useHandleStatusRequest({
        id: 'sendToSap',
        title: 'Send To Sap',
        onSuccess,
    })

    return useMutation({
        mutationFn: ({
            selectedInvoiceId,
        }: {
            selectedInvoiceId: number,
        }) => {
            return simpleApi({
                ...requests.sendToSap({
                    outgoingInvoiceId: selectedInvoiceId,
                }),
                token,
            })
        },
        onSuccess: onSuccessRequest,
        onError: onErrorRequest,
    })
}

export default useSendToSap
